import type { LedgerOption, RefType } from '@/api/accountsBooks';

/** Formatting and small helpers the voucher forms share. */

export const r2 = (x: number) => Math.round(x * 100) / 100;
/** ₹1,85,400.00 — always two decimals, as the prototype shows money. */
export const inr = (n: number) => `${n < 0 ? '−' : ''}₹${Math.abs(r2(n)).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
/** "₹1,25,000.00 Dr" — signed: + Dr, − Cr. */
export const drcr = (n: number) => `${inr(Math.abs(n))} ${n >= 0 ? 'Dr' : 'Cr'}`;
export const curBal = (l?: LedgerOption) => (l ? drcr(l.balance) : '—');
export const cashBank = (l?: LedgerOption) => l?.kind === 'cash' || l?.kind === 'bank';
export const dayName = (d: string) => (d ? new Date(`${d}T00:00:00Z`).toLocaleDateString('en-IN', { weekday: 'long', timeZone: 'UTC' }) : '');
/** DD-MM-YYYY */
export const dd = (d: string | null | undefined) => (d ? `${d.slice(8, 10)}-${d.slice(5, 7)}-${d.slice(0, 4)}` : '');
export const daysBetween = (from: string, to: string) => Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000);

/** A bill-wise line on a party: Agst Ref names an open bill; the others are new. */
export interface Ref { t: RefType; name: string; amt: number }

/** Ledgers with their balance as it stood without the voucher being altered (as the prototype shows Cur Bal). */
export function withoutVoucher(ledgers: LedgerOption[], voucher: { lines: { ledgerId: number; side: 'Dr' | 'Cr'; amount: number }[] } | null): LedgerOption[] {
  if (!voucher) return ledgers;
  const own = new Map<number, number>();
  for (const l of voucher.lines) own.set(l.ledgerId, (own.get(l.ledgerId) ?? 0) + (l.side === 'Dr' ? l.amount : -l.amount));
  return ledgers.map((l) => (own.has(l.id) ? { ...l, balance: r2(l.balance - own.get(l.id)!) } : l));
}
